export const findAlias = (json, key, stateAliases, frameType) => {
  if (frameType === "FIRAXL" && key === "FRONT_TOP") {
    key = "FRONT_TOP_FULL";
  }
  return stateAliases[json[key]];
};
